import React from "react";

var jose = require('node-jose');

const jwtContext = React.createContext();

export function useJWT() {
    return React.useContext(jwtContext);
}

function useProvideJWT() {
    const [token, setToken] = React.useState(localStorage.getItem('token') || "");
    const [claims, setClaims] = React.useState("loading");

    React.useEffect(() => {
        if (token !== "") {
            console.debug("processing token: ", token);
            jose.JWK.asKey(process.env.REACT_APP_JWT_CERT, "pem").then(key => {
                jose.JWS.createVerify(key).verify(token, {algorithms: ["RS256"]}).then(rawClaims => {
                    let newClaims = JSON.parse(rawClaims.payload.toString());
                    if (newClaims.aud !== `app.${process.env.REACT_APP_DOMAIN}`) {
                        throw new Error(`unexpected 'aud': ${newClaims.aud}`);
                    }
                    let now = Math.floor(Date.now() / 1000);
                    if (now > newClaims.exp) {
                        throw new Error(`expired 'exp': ${newClaims.exp} is < ${now}`);
                    }
                    console.debug("verified claims: ", newClaims);
                    setClaims(newClaims);
                }).catch(error => {
                    console.error("verifying jwt: ", error);
                    setClaims("");
                    deleteToken();
                })
            }).catch(error => {
                console.error("loading key: ", error);
                setClaims("");
                deleteToken();
            })
        } else {
            setClaims("");
        }
    }, [token]);

    const saveToken = (newToken, cb) => {
        console.debug("saving token");
        setClaims("loading");
        localStorage.setItem("token", newToken);
        setToken(newToken);
        cb();
    };

    const deleteToken = cb => {
        console.debug("deleting token");
        setToken("");
        localStorage.removeItem("token");
        if (cb) {
            cb();
        }
    };

    return {
        token,
        claims,
        saveToken,
        deleteToken
    }
}

export function JWTProvider({ children, ...rest }) {
    const jwt = useProvideJWT();
    if (jwt.claims === "loading") {
        console.debug("rendering blocked until jwt loading completes");
        return null;
    }
    return (
        <jwtContext.Provider value={jwt}>
        {children}
        </jwtContext.Provider>
    );
}
